import { render, staticRenderFns } from "./AppleCareSwiper.vue?vue&type=template&id=159eb1f5&scoped=true"
import script from "./AppleCareSwiper.vue?vue&type=script&lang=js"
export * from "./AppleCareSwiper.vue?vue&type=script&lang=js"
import style0 from "./AppleCareSwiper.vue?vue&type=style&index=0&id=159eb1f5&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159eb1f5",
  null
  
)

export default component.exports